import { XbpmFormulaType } from './xbpm.enums';
// formulas definition
export var FormulaChangeProperty;
(function (FormulaChangeProperty) {
    FormulaChangeProperty["HIDDEN"] = "hidden";
    FormulaChangeProperty["DISABLED"] = "disabled";
    FormulaChangeProperty["READONLY"] = "readonly";
    FormulaChangeProperty["VALUE"] = "value";
    FormulaChangeProperty["SUPPORTED_VALUES"] = "supportedValues";
    FormulaChangeProperty["OPTIONS"] = "frontOptions";
    FormulaChangeProperty["ACTIVE_INDEX"] = "activeIndex";
})(FormulaChangeProperty || (FormulaChangeProperty = {}));
export var FORMULA_ALLOWED_CHANGES_LIST = Object.values(FormulaChangeProperty);
export var FORMULA_TYPES_LIST = Object.values(XbpmFormulaType);
export var TABLE_ROW_FORMULA_TYPES_LIST = [
    XbpmFormulaType.CLICK,
    XbpmFormulaType.FIND_PLACE,
    XbpmFormulaType.FIND_BLOCK,
    XbpmFormulaType.REQUEST,
    XbpmFormulaType.OK,
    XbpmFormulaType.ERR,
];
export var FormElementChangedBy;
(function (FormElementChangedBy) {
    FormElementChangedBy["USER"] = "USER";
    FormElementChangedBy["FORMULA"] = "FORMULA";
})(FormElementChangedBy || (FormElementChangedBy = {}));
//# sourceMappingURL=formula.types.js.map